/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export function startServer(_: any): any {
	throw new Error('Not implemented');
}

export function createServer(_: any): any {
	throw new Error('Not implemented');
}

export class LoopbackAuthServer {
	constructor(..._args: any[]) {
		throw new Error('Not implemented');
	}
}
